<template>
	<div class="brie" ref="brie">
		<brieHeader :types="topFlag ? '1' : '2'" />
		<el-carousel :height="'590px'">
			<el-carousel-item v-for="item in bgImgs" :key="item.id">
				<img class="bgimg" :src="$imgUrl + item.bannerImg" alt="" />
			</el-carousel-item>
		</el-carousel>
		<div class="lbBox">
			<div class="lbItem">
				<div class="lbImg"><img src="@/assets/img/zy.svg" alt="" /></div>
				<div class="lbCont">
					<div class="lbTit">专业</div>
					<p>拥有近百位专业编辑老师</p>
				</div>
			</div>
			<div class="lbItem">
				<div class="lbImg"><img src="@/assets/img/tx.svg" alt="" /></div>
				<div class="lbCont">
					<div class="lbTit">贴心</div>
					<p>各校配备辅助教学专员</p>
				</div>
			</div>
			<div class="lbItem">
				<div class="lbImg"><img src="@/assets/img/xinlai.svg" alt="" /></div>
				<div class="lbCont">
					<div class="lbTit">信赖</div>
					<p>教辅产品多重审查机制</p>
				</div>
			</div>
		</div>
		<div class="jsBox">
			<h3>公司简介</h3>
			<div class="jsImg">COMPANNY</div>
			<div class="jsP" v-html="gwCont.content"></div>
			<!-- <div class="jsVivo">
                <myVideo height="367" :videoUrl="demos"></myVideo>
            </div> -->
		</div>
		<!-- <div class="qyBox">
            <h3>企业资质</h3>
            <div class="jsImg">
                QUALIFICATIONS
            </div>
            <div class="qyCont">
                <div class="qyImg">
                    <img v-for="(item,index) in zizImgs" :key="index" :src="$imgUrl+item.bannerImg" alt="">
                </div>
                <div class="qyH"></div>
            </div>
        </div>
        <div class="hzBox">
            <h3>合作名校</h3>
            <div class="jsImg">
                SCHOOL
            </div>
            <div class="hzH">
                <div class="hzsBox" :style="{'width': 341 * bgBotImgs.length + 'px'}">
                    <div class="hzItem" v-for="(item, index) in bgBotImgs" :key="index">
                        <img :src="$imgUrl+item.bannerImg" alt="">
                    </div>
                </div>
            </div>
        </div> -->
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import brieHeader from '@/components/hearder/brieHeader';
import demos from '@/assets/mp4/demo.mp4';
// 引入Swiper组件和样式
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

export default {
	name: 'briefIntr',
	data() {
		return {
			bgImgs: [],
			bgBotImgs: [],
			banList: [],
			zizImgs: [],
			gwCont: {},
			topFlag: true,
			canSlide: true,
			swiperOption: {
				loop: true,
				autoplay: {
					delay: 2500, // 自动切换时间间隔，单位为ms
					disableOnInteraction: false // 用户操作后是否继续自动切换，设为false则继续自动切换
				},
				initialSlide: 0, //初始化页码
				observer: true, //修改swiper自己或子元素时，自动初始化swiper
				observeParents: true, // 修改swiper的父元素时，自动初始化
				centeredSlides: true,
				slidesPerView: 'auto',
				effect: 'coverflow', //异性的solid模式,中间的大，两边缩小
				coverflowEffect: {
					rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
					stretch: 0, //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
					depth: 0, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
					modifier: 1, //depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
					slideShadows: false //开启slide阴影。默认 true。
				},
				on: {
					slideChange: () => {
						if (this.canSlide) {
							// this.canSlide = false; // 滑动后禁用滑动
							// 可以在这里执行其他操作，比如更新canSlide的值等
							// this.$refs.mySwiper.swiper.allowTouchMove = false
						}
					}
				}
			},
			demos
		};
	},
	components: {
		brieHeader,
		foot,
		swiper,
		swiperSlide
	},
	methods: {
		init() {
			this.$http.get(`api/platform/agreement/1`).then((res) => {
				console.log(res, 7777);
				this.gwCont = res.data;
			});
			this.$http
				.get(`api/app/yydBanner/list`, {
					params: {
						type: 8
					}
				})
				.then((res) => {
					this.zizImgs = res.data;
					console.log(res, 7777);
				});
			this.$http
				.get('api/app/yydBanner/list', {
					params: {
						type: 1
					}
				})
				.then((res) => {
					console.log(res);
					this.bgImgs = res.data;
				});
			this.$http
				.get('api/app/yydBanner/list', {
					params: {
						type: 2
					}
				})
				.then((res) => {
					console.log(res);
					// if(res.data){
					//     let num = 1000
					//     for(let i=0;i<Math.floor(1000/res.data.length);i++){
					//         res.data.push(...res.data)
					//     }
					// }
					// this.bgBotImgs = res.data || []
					// this.$nextTick(() => {
					//     this.$refs.mySwiper.swiper.slideTo(Math.floor((res.data.length-1) / 2), 500, false);
					// });
				});
		},
		handleScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			const isAtTop = scrollTop === 0;
			if (isAtTop) {
				this.topFlag = true;
			} else {
				if (this.topFlag) {
					this.topFlag = false;
				}
			}
		}
	},
	mounted() {
		this.init();
		window.addEventListener('scroll', this.handleScroll, true);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	}
};
</script>
<style lang="scss" scoped>
.el-carousel__item h2 {
	color: #475669;
	font-size: 18px;
	opacity: 0.75;
	line-height: 300px;
	margin: 0;
}

.el-carousel__item:nth-child(2n) {
	background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
	background-color: #d3dce6;
}
/* css创建动画 */
@keyframes move {
	from {
		transform: translateX(0);
	}
	to {
		transform: translateX(-90%);
	}
}

.lbBox {
	width: 1200px;
	margin: -20px auto 0;
	display: flex;
	justify-content: space-between;
	position: relative;
	z-index: 99999;
	.lbItem {
		width: calc((100% - 40px) / 2);
		height: 190px;
		margin-right: 20px;
		background: #fff;
		border-radius: 6px;
		cursor: pointer;
		display: flex;
		align-items: center;
		padding-left: 28px;
		box-sizing: border-box;
		box-shadow: 0px 5px 12px 0px rgba(0, 0, 0, 0.07);
		&:last-of-type {
			margin-right: 0;
		}
		.lbImg {
			width: 81px;
			height: 81px;
			margin-right: 32px;
			img {
				width: 100%;
			}
		}
		.lbCont {
			.lbTit {
				font-size: 28px;
				color: #000000;
				margin-bottom: 22px;
				font-weight: bold;
			}
			p {
				font-size: 14px;
				color: #9d9d9d;
			}
		}
	}
}
.jsImg {
	text-align: center;
	font-size: 38px;
	color: #e8e8e8;
	margin: 4px 0 14px;
}
.jsBox {
	margin: 83px auto 73px;
	width: 1200px;
	.jsP {
		text-align: left;
		line-height: 2;
		color: #616263;
		text-indent: 2em;
	}
	.jsVivo {
		margin: 38px auto 0;
		width: 866px;
		height: 367px;
	}
}
h3 {
	font-size: 30px;
	font-weight: bold;
	color: #000000;
	text-align: center;
}
.brie {
	background: #f0f2f5;
}
.hzBox {
	padding: 54px 0 80px;
	overflow: hidden;
	.hzH {
		margin: 45px 0 0;
		.hzsBox {
			min-width: 3000px;
			animation-name: move;
			animation-duration: 1200s;
			animation-iteration-count: infinite;
			animation-timing-function: linear;
		}
		.hzItem {
			width: 299px;
			margin-right: 42px;
			height: 185px;
			float: left;
			img {
				width: 100%;
				height: 100%;
				border-radius: 16px;
				object-fit: cover;
			}
		}
	}
}
.qyBox {
	padding-top: 54px;
	background: #fff;
	.qyCont {
		margin-top: 34px;
		.qyH {
			height: 145px;
			background: #317245;
		}
		.qyImg {
			height: 307px;
			width: 1200px;
			margin: 0 auto -85px;
			position: relative;
			z-index: 1;
			display: flex;
			justify-content: center;
			img {
				width: 216px;
				height: 307px;
				margin-right: 10px;
				&:last-child {
					margin-right: 0;
				}
			}
		}
	}
}
.bgimg {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
</style>
